module.exports = __webpack_public_path__ + "img/shutterstock_160644944.9d5f0fa8.png";